import { Badge } from 'slab'

const StatusBadge = ({ status }: { status: string }) => {
  switch (status) {
    case 'active':
      return <Badge type='success'>Active</Badge>
    case 'inactive':
      return <Badge type='neutral'>Inactive</Badge>
    default:
      return <Badge type='neutral'>{status}</Badge>
  }
}

export default StatusBadge
